import React from 'react';
import { formatMoney, formatNumber, checkUndefine } from '../../../../../helpers/functions';
import { Input as AntInput } from 'antd';
import './styles.less';
import { values } from 'lodash';
export default class Input extends AntInput {

    state = {
        hasNumberDot: false
    };

    render() {
        const { className, value, type, nullable, ...restProps } = this.props;
        return (
            <AntInput {...restProps}
                type={this.getType()}
                value={this.formatValue(value)}
                onChange={this.onChange}
                className={`hms-input ${className} ${type === 'currency' ? 'text-right' : ''}`} />
        )
    }

    onChange = (event) => {
        const { type, nullable } = this.props;
        let value = event.target.value;
        if (type) {
            switch (type.toLowerCase()) {
                case 'currency':
                    const hasNumberDot = (value || '').endsWith('.') && (value || '').split('.').length <= 2;
                    this.setState({ hasNumberDot });
                    const normalizedValue = value.replace(/[^0-9.,]/g, "");
                    event.target.value = nullable && normalizedValue === ""
                        ? ""
                        : Number(formatNumber(normalizedValue, false));
                    break;
                default:
                    break
            }
        };
        return this.props.onChange(event);
    }

    formatValue = (value) => {
        const { type } = this.props;
        const { hasNumberDot } = this.state;
        if (!type) return value;
        switch (type.toLowerCase()) {
            case 'currency':
                let dotString = hasNumberDot ? '.' : '';
                return value === 0 ? 0 : checkUndefine(formatMoney(value, false) + dotString, true);
            default:
                return value
        }

    }

    getType = () => {
        const { type } = this.props;
        if (!type) return undefined;
        switch (type.toLowerCase()) {
            case 'currency':
                return 'text';
            default:
                return type
        }
    }
}
Input.defaultProps = {
    onChange: (event) => { }
};
export const InputGroup = AntInput.Group;
